export function getAuthHeaderFromCredentials(
  username: string,
  password: string
): string {
  const combinedCredentials = username + ':' + password;
  const encoder = new TextEncoder();
  const data = encoder.encode(combinedCredentials);
  const base64Credentials = btoa(String.fromCharCode(...data));

  return 'Basic ' + base64Credentials;
}
